import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import LinkedMetadataIconsContainer from './LinkedMetadataIconsContainer'

type SourceIconProps = {
  children: React.ReactElement
  message: string
  url: string
}

const SourceIcon = ({ children, message, url }: SourceIconProps) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  return (
    <Tooltip mode={theme} enabled content={t('viewPostsOnWebsite')}>
      <div>
        <LinkedMetadataIconsContainer message={message} url={url}>
          {children}
        </LinkedMetadataIconsContainer>
      </div>
    </Tooltip>
  )
}

export default SourceIcon
